function filterDropdownItems(searchTerm, panel) {
  if (!panel) return;
  
  const searchLower = searchTerm.toLowerCase().trim();
  const items = panel.querySelectorAll(".disclosure__item");
  const noResults = panel.querySelector(".localization-no-results");
  let visibleCount = 0;

  items.forEach((item) => {
    const countryName = item.getAttribute("data-country-name") || "";
    const currency = item.getAttribute("data-currency") || "";
    const languageName = item.getAttribute("data-language-name") || "";
    const linkText = item.querySelector("a")?.textContent?.toLowerCase() || "";
    
    const matches = 
      countryName.includes(searchLower) ||
      currency.includes(searchLower) ||
      languageName.includes(searchLower) ||
      linkText.includes(searchLower);

    if (matches || searchTerm === "") {
      item.style.display = "";
      visibleCount++;
    } else {
      item.style.display = "none";
    }
  });

  // Show/hide no results message
  if (noResults) {
    if (visibleCount === 0 && searchTerm !== "") {
      noResults.style.display = "block";
    } else {
      noResults.style.display = "none";
    }
  }
}

if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]'
          ),
          button: this.querySelector("button"),
          panel: this.querySelector(".disclosure__list-wrapper"),
          searchInput: this.querySelector(".localization-search-input"),
          noResults: this.querySelector(".localization-no-results"),
        };

        this.querySelectorAll("a").forEach((item, index) => {
          item.addEventListener("click", this.onItemClick.bind(this));
        });

        // Add click listener to buttons as well
        this.querySelectorAll("button").forEach((item, index) => {
          item.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            // Check if this is mobile
            const isMobile = window.innerWidth <= 1025;
            const isMobileLanguage = this.closest('.mobile-language');
            
            // Close all other dropdowns first
            const selector = isMobileLanguage 
              ? '.mobile-language .disclosure__list-wrapper'
              : '.header .disclosure__list-wrapper, .header__logo .disclosure__list-wrapper, .mobile-language .disclosure__list-wrapper';
            
            document.querySelectorAll(selector).forEach(dropdown => {
              if (dropdown !== this.elements.panel) {
                dropdown.setAttribute("hidden", "true");
                const button = dropdown.closest('.disclosure')?.querySelector('.disclosure__button');
                if (button) button.setAttribute("aria-expanded", "false");
              }
            });
            
            // Toggle current panel visibility
            if (this.elements.panel) {
              const isHidden = this.elements.panel.hasAttribute("hidden");
              if (isHidden) {
                this.elements.panel.removeAttribute("hidden");
                this.elements.button.setAttribute("aria-expanded", "true");
                // Focus search input when opening (desktop only, mobile keyboard handling)
                if (this.elements.searchInput && !isMobile && this.elements.searchInput.offsetParent !== null) {
                  setTimeout(() => this.elements.searchInput.focus(), 100);
                }
              } else {
                this.elements.panel.setAttribute("hidden", "true");
                this.elements.button.setAttribute("aria-expanded", "false");
                // Clear search when closing
                if (this.elements.searchInput) {
                  this.elements.searchInput.value = "";
                  filterDropdownItems("", this.elements.panel);
                }
              }
            }
          });
        });
        
        // Store reference for click-outside handler
        this._handleClickOutside = (e) => {
          if (!this.contains(e.target) && this.elements.panel && !this.elements.panel.hasAttribute("hidden")) {
            this.elements.panel.setAttribute("hidden", "true");
            if (this.elements.button) {
              this.elements.button.setAttribute("aria-expanded", "false");
            }
            if (this.elements.searchInput) {
              this.elements.searchInput.value = "";
              filterDropdownItems("", this.elements.panel);
            }
          }
        };
        
        // Add single click-outside listener (will be cleaned up in disconnectedCallback if needed)
        if (this.elements.panel) {
          setTimeout(() => {
            document.addEventListener('click', this._handleClickOutside, true);
          }, 0);
        }

        // Add search functionality
        if (this.elements.searchInput) {
          this.elements.searchInput.addEventListener("input", (e) => {
            filterDropdownItems(e.target.value, this.elements.panel);
          });

          // Prevent dropdown from closing when clicking on search input
          this.elements.searchInput.addEventListener("click", (e) => {
            e.stopPropagation();
          });
          
          // Handle mobile keyboard
          this.elements.searchInput.addEventListener("focus", (e) => {
            // Scroll input into view on mobile
            if (window.innerWidth <= 1025) {
              setTimeout(() => {
                e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }, 300);
            }
          });
          
          // Close keyboard on blur (mobile)
          this.elements.searchInput.addEventListener("blur", (e) => {
            // Small delay to allow item clicks
            setTimeout(() => {
              if (window.innerWidth <= 1025 && document.activeElement !== this.elements.button) {
                // Keep dropdown open but allow keyboard to close
              }
            }, 100);
          });
        }

        // Initialize panel as hidden
        if (this.elements.panel) {
          this.elements.panel.setAttribute("hidden", "true");
        }
        if (this.elements.button) {
          this.elements.button.setAttribute("aria-expanded", "false");
        }
      }

      hidePanel() {
        if (this.elements.button) {
          this.elements.button.setAttribute("aria-expanded", "false");
        }
        if (this.elements.panel) {
          this.elements.panel.setAttribute("hidden", true);
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        const isCountryLink = event.currentTarget?.className.includes("country-link");
        const targetElementV = event.currentTarget.getAttribute("data-value");

       
        if (isCountryLink) {
          // Handle country selection
          if (this.elements.input) {
            this.elements.input.value = event.currentTarget.dataset.value;
          }
          if (form) {
            form.submit();
          }
        } else {
          // Handle language selection
          if (this.elements.input) {
            this.elements.input.value = targetElementV;
          }
          if (form) {
            form.submit();
          }
        }
      }
    }
  );
}
